import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Icon } from 'apps/shared/scripts/components';

import {
  cardDeliveryWarningClassName,
  iconClassName,
  mediaClassName,
  subtitleClassName,
  textClassName,
  titleClassName,
} from './styles';

const CardDeliveryWarning = () => {
  return (
    <ContentCard>
      <div className={cardDeliveryWarningClassName}>
        <div className={mediaClassName}>
          <Icon className={iconClassName} fa={faCalendarCheck} />
        </div>
        <div className={textClassName}>
          <h2 className={titleClassName}>
            Your card will be delivered immediately
          </h2>
          <h4 className={subtitleClassName}>
            Once the card has been sent, the action may not be undone. Please
            take a moment to verify all details before clicking send.
          </h4>
        </div>
      </div>
    </ContentCard>
  );
};

CardDeliveryWarning.displayName = 'CardDeliveryWarning';

export default CardDeliveryWarning;
